module.exports = {
  isHeadwayTail: 'HeadwayTail',
  containerLoadType: 'ContainerLoadType',
  transportType: 'TransportType',
  fullHalf: 'Full/Half',
  transportLine: 'TransportLine',
  ETD: 'ETD',
  ETA: 'ETA',
  ATD: 'ATD',
  ETD2: 'ETD',
  ETA2: 'ETA',
  ATD2: 'ATD',
  ATA2: 'ATA',
  departureStation: 'DepartureStation',
  departureStationRe: 'DepartureStation(Railway)',
  transferStation: 'TransferStation',
  transitStation: 'TransitStation',
  destinationStation: 'DestinationStation',
  destinationStationRe: 'DestinationStation(Railway)',
  destinationCountry: 'DestinationCountry',
  portAgent: 'PortAgent',
  forwardingAgent: 'Forwarding agent',
  paymentMethod: 'PaymentMethod',
  mbl: 'MBL',
  vessel: 'Vessel',
  voyageFlight: 'VoyageFlight',
  isDiffPlacesCollaborate: 'isDiffPlacesCollaborate',
  loadingPlaceCompany: 'LoadingPlaceCompany',
  signBillPlaceCompany: 'SignBillPlaceCompany',
  isFullShipment: 'isFullShipment',
  dischargePortCompany: 'DischargePortCompany',
  destinationPortCompany: 'DestinationPortCompany',
  overseaOp: 'OverseaOp',
  planner: 'Planner',
  plannerOffice: '路線会社',
  plannerDepartment: 'ルート部門',
  batchVessel: 'BatchVessel',

  Query: '查询',
  BuyContainer: '买箱',
  CallContainer: '调箱',
  SellContainer: '卖箱',
  RentContainer: '租箱',
  ClearContainerLog: '清除调箱记录',
  ReturnBox: '还箱',
  Edit: '编辑',
  Delete: '删除',
  OrderNo: '订单号',
  OrderNo2: 'Order No',
  JobNo2: 'Job No',
  ConsignationCompany: '委托客户',
  BoxOwner: '箱主/卖家',
  BoxOwner3: 'BoxOwner',
  BoxOwner2: '卖方',
  Buyer2: '买方',
  Buyer: 'Buyer',
  OrderType: '订单类型',
  ContainerStatus: '箱子状态',
  ContainerType: '箱子类型',
  Amount: '金额',
  WhetherSettlement: '是否结算',
  SettlingTime: '结算日期',
  BuyerTime: '买箱日期',
  SellTime: '卖箱日期',
  ReturnTime: '退还日期',
  OperationTime: '操作日期',
  Prompt1: '请输入订单号',
  Prompt2: '请输入箱号',
  QuantitySum: '总箱量',
  AmountSum: '总金额',
  Quantity2: '数量',
  BuyTime: '购买日期',
  SellerDate: '出售日期',
  RentDate: '起租日期',
  StartRentDate: '起租日期',
  ReturnDate: '结束日期',
  UnitRate: '单价',
  ContainerNo: '箱号',
  CurrencyCode: 'Currency Code',
  EQSize: '箱型',
  EQType: '箱种',
  EQQuantity: '箱数',
  Add: '新增',
  Confirm: '确认',
  Cancel: '取消',
  Operation: '操作',
  UnitRate2: '单价（RMB/天）',
  UnitRate3: 'RMB/天',
  ReturnBoxDate: '还箱时间',
  Term: '期限',
  Day: '天',
  UnitPriceInterval: '单价区间',
  BuyBoxTotalTankVolume: 'Buy Box Total Tank Volume',
  TotalCost: 'Total cost',
  SellOutTotalTankVolume: 'Sell out Total tank volume',
  TotalSalesAmount: 'Total sales amount',
  CostUnitPrice: 'Cost unit price',
  CostUnitPriceCurrencyCode: 'Cost unit price currency code',
  SellingUnitPrice: 'Selling unit price',
  SellingUnitPriceCurrencyCode: 'Selling unit price currency code',
  ETDNotNull: 'Ship date cannot be blank.',
  ETANotNull: 'Arrival date cannot be blank.',
  PaymentMethodCannotBlank: 'Payment method cannot be blank',
  DepartureStationCannotEmpty: 'The departure station cannot be empty',
  TransferStationCannotEmpty: 'The transfer station cannot be empty',
  TransitStationCannotEmpty: 'The transit station station cannot be empty',
  DestinationStationCannotEmpty: 'The destination station cannot be empty',
  CharacterLengthTooLongMaintainAgain: 'Character length is too long, please maintain again!',
  TheNotOnTheBustrain: 'The selected documents are not on the same bus/train',
  OperationFailed: 'Operation failed',
  SelectTime: 'Select time',
  BulkModifyDestinationPortInformation: 'Bulk modify destination port information',
  NonWarehouseOverseasTransferWarehouse: 'Non-Amazon warehouse overseas transfer warehouse',
  EstimatedDeliveryTime: 'Estimated delivery time',
  ActualDeliveryTime: 'Actual delivery time',
  DomesticWarehouse: 'Domestic warehouse',
  OverseasWarehouse: 'Overseas warehouse',
  WithCostRefundForClearing: '(With cost refund for clearing)',
  TheExpiresAndNoCreated: 'The contract of this entrusted unit expires and no new business can be created',
  DueNotBePrintedNeeded: 'Due to credit control, this bill has been locked and can not be printed or EDI. Please contact the superior to unlock when needed!',
  LockedPleaseContactTheUnlock: 'Locked and cannot be printed. Please contact the superior manager to unlock!',
  FCLProfitPrint: 'FCL Profit Print',
  AttachmentContentTooLarge: 'Attachment content too large',
  LCLProfitPrint: 'LCL Profit Print',
  ContainerType2: 'Container type',
  AdjustmentOperation: 'Adjustment operation',
  All: 'All',
  Days: 'Days',
  ExpectedToEnterAmazonWarehouse: 'Expected time to enter Amazon warehouse',
  ReferenceContainerNumber: 'Reference container number',
  Export: 'Export',
  Import: 'Import',
  ReturnContainer: 'Return container',
  PleaseEnterContainerInformation: 'Please enter container information！',
  PleaseEnterReturnContainerTime: 'Please enter return container time！',
  ReturnSuccessfulSuccessfulReturnCount: 'Return container operation successful! Successful return container count:',
  NumberOfContainerPieces: 'Number of container pieces:',
  GreaterActualNumberOfPieces: 'Greater than the actual number of pieces:',
  ContainerWeight: 'Container weight:',
  GreaterThanTheActualWeight: 'Greater than the actual weight:',
  ContainerVolume: 'Container volume:',
  GreaterThanTheActualVolume: 'Greater than the actual volume:',
  JobNumber: 'Job number:',
  ServiceChannel: 'Service channel',
  PostalCode: 'Postal code',
  DestinationDeliveryMethod: 'Destination delivery method',
  ExpressCompany: 'Express company',
  TrackingNumber: 'Tracking number',
  POoriginalOrderNumber: 'PO (original order number)',
  CustomsDeclarationMethod: 'Customs declaration method',
  CustomsClearanceMethod: 'Customs clearance method',
  EORIEnterpriseNumber: 'EORI enterprise number',
  VATtaxNumber: 'VAT/tax number',
  VATRegistrationCountry: 'VAT registration country',
  VATRegistrationAddress: 'VAT registration address',
  VATCompanyEnglishName: 'VAT company English name',
  WithBattery: 'With battery',
  WithMagnet: 'With magnet',
  Powder: 'Powder',
  Liquid: 'Liquid',
  EstimatedStoragegoodsReadyTime: 'Estimated storage/goods ready time',
  RemoteWarehouse: 'リモート倉庫',
  ThisHasExpiredCannotBusiness: 'This entrusting unit contract has expired, cannot create business',
  Freight: 'Freight',
  ServiceChannel2: 'Service channel:',
  CostType: 'Cost type:',
  EstimatedAmount: 'Estimated amount:',
  EquivalentTo: 'Equivalent to',
  FareLevel: 'Fare level:',
  BillingWeight: 'Billing weight:',
  CalculationMethod: 'Calculation method:',
  TheTypeCannotBeEmpty: 'The entrustment type cannot be empty',
  TransportTypeCannotBeEmpty: 'Transport type cannot be empty',
  FullJourneyCannotBeEmpty: 'Full journey/half journey cannot be empty',
  ShippingRouteCannotBeEmpty: 'Shipping route cannot be empty',
  DepartureBeLaterThanDate: 'Departure date cannot be later than arrival date',
  DepartureStationCannotBeEmpty: 'Departure station cannot be empty',
  TransitStationCannotBeEmpty: 'Transit station cannot be empty',
  TransitStationCannotBeEmpty2: 'Transit station cannot be empty',
  DestinationStationCannotBeEmpty: 'Destination station cannot be empty',
  PaymentMethodCannotBeEmpty: 'Payment method cannot be empty',
  SalesCannotBeEmpty: 'Sales cannot be empty',
  OperationCannotBeEmpty: 'Operation cannot be empty',
  AlreadyOtherBoxTypesTime: 'Already selected [open-top/gondola/flat], cannot choose other box types at the same time!',
  EstimatedTimeCannotBeEmpty: 'Estimated warehouse/goods ready time cannot be empty!',
  DestinationCannotBeEmpty: 'Destination cannot be empty!',
  DestinationCountryCannotBeEmpty: 'Destination country cannot be empty!',
  ZipCodeCannotBeEmpty: 'Zip code cannot be empty!',
  CannotBeEmpty: 'Cannot be empty!',
  PleaseTheEntrustingUnitFirst: 'Please select the entrusting unit first.',
  EstimatedStoragegoodReadyTime: 'Estimated storage/good ready time',
  NoTicketChecked: 'No ticket checked',
  CustomersOwnContainer: 'Customer\'s own container',
  CompanyOwnedContainer: 'Company-owned container',
  RentalContainer: 'Rental container',
  ContainerUsageImportTemplateRailwayXls: 'ContainerUsageImportTemplate(Railway).xls',
  CurrentBeenSubmittedCannotOperate: 'Current business has been submitted, cannot operate!',
  AreWantToPerformOperation: 'Are you sure you want to perform this operation?',
  CostNotConfiguredPleaseCheck: 'Cost type is not configured, please check!',
  CostAuditedOrInvoicedCheck: 'Cost has been audited or invoiced, please check!',
  CleaningCompletedSuccessfulCleaningNumber: 'Cleaning completed! Successful cleaning number:',
  PleaseBoxesYouWantProcess: 'Please check the boxes you want to process!',
  ContainsContainerDataPleaseCheck: 'Contains unadjusted container data, please check!',
  PleaseSelectAContainer: 'Please select a container',
  FirstLeglastLeg: 'First leg/last leg',
  TransportationMethod: 'Transportation method',
  ContactPerson: 'Contact person',
  DetailedAddress: 'Detailed address',
  FirstLeglastLegInformation: 'First leg/last leg information',
  CustomerDoordestinationPortDoor: 'Customer door/destination port door',
  CustomerContactPerson: 'Customer contact person',
  FirstLegCannotBeEmpty: 'First leg/last leg cannot be empty',
  PleaseEnterTransportationCompanyInformation: 'Please enter transportation company information',
  PleaseSelectDesignatedData: 'Please select designated data',
  PleaseSelectTradeInformation: 'Please select trade information.',
  RailwayOperationGoodsDetails: 'Railway operation goods details',
  SellingContainer: 'Selling container',
  TotalPurchaseContainer: 'Total purchase container',
  TotalCostAmount: 'Total cost amount',
  TotalSoldContainer: 'Total sold container',
  TotalSellingAmount: 'Total selling amount',
  ModificationSuccessful: 'Modification successful',
  BuyingContainer: 'Buying container',
  Yes: 'Yes',
  No: 'No',
  PleaseTheContainerToEdit: 'Please select the container to edit!',
  EditOrderInformation: 'Edit order information',
  PleaseTheContainerToDelete: 'Please select the container to delete!',
  AreWantToDeleteInformation: 'Are you sure you want to delete this container information?',
  PromptInformation: 'Prompt information',
  DeletingOrderContainsOccupiedContainers: 'Deleting order contains occupied containers!',
  CurrentlySelected: '(Currently selected)',
  CurrentPage: '(Current page)',
  CurrentlyAvailable: 'Currently available',
  CurrentlyOccupied: 'Currently occupied',
  Sold: 'Sold',
  ContainerInquiry: 'Container inquiry',
  BoxReturnedCannotContinueOperate: 'Box number: {0}, already returned, cannot continue to operate!'
}
